// extracted by mini-css-extract-plugin
export var downArrow = "_g1-0";
export var infoTooltipIcon = "_g1-3";
export var label = "_g1-1";
export var optionCard = "_g1-4";
export var upArrow = "_g1-2";